module.exports = __webpack_public_path__ + "img/img_logo.f2ab86b3.svg";